import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";
import { PagerService } from "../../core/services/pager.service";

@Component({
  selector: "app-countryconfiguration",
  templateUrl: "./countryconfiguration.component.html",
  styleUrls: ["./countryconfiguration.component.css"],
})
export class CountryconfigurationComponent implements OnInit {
  public successfulData: any = [];
  DeviceTypeList;
  Device;
  Countries;
  AGList: any[];
  UseCaseList: any[];
  CountryCodeDetails;

  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];

  public country = "";
  public Type = "";
  public LoginEnterpriseID = "";
  public Country = "";
  public DeviceType;
  public Role = "";
  dataLoader: boolean;

  constructor(
    private router: Router,
    private capservice: CAPService,
    private _avRoute: ActivatedRoute,
    private pagerService: PagerService
  ) {
    this.LoginEnterpriseID = capservice.enterpriseid;
    this.Role = capservice.Role;
    this.Country = capservice.country;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == undefined) {
      // $location.path("/LoginInvalid");
      // $route.reload();
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit(): void {

    this.dataLoader = true;
    this.successfulData = {
      Id: "",
      Name: "",
      Code: "",
      AG: "",
      UseCase: "",
      ID1: "",
      DeviceType: "",
      strType: "",
      EnterpriseID: "",
      token: "",
    };
    this.CountryCodeDetails = {
      Name: "",
      Code: "",
      AG: "",
      UseCase: "",
      DeviceType: "",
      EnterpriseID: "",
      strType: "",
      token: "",
    };
    this.DeviceTypeList = [
      // { name: 'Skype', },
      { name: "Cisco" },
      { name: "Teams" },
    ];
    this.GetCountryList();
    this.GetDropDownValues();
    this.AudiLogin();
  }
  AudiLogin() {
    this.capservice
      .AudiLogin("CountryCodeConfiguration", this.LoginEnterpriseID)
      .subscribe((data) => {});
  }
  validateNumber(e: any) {
    let input = String.fromCharCode(e.charCode);
    const reg = /^[\d +-]+$/;

    if (!reg.test(input)) {
      e.preventDefault();
    }
  }
  GetCountryList() {
    this.capservice.CountryList(this.country, this.Type).subscribe((data) => {
      this.Countries = data;
    });
  }
  InitLoad() {
    this.capservice
      .GetVoiceAdminDetails(this.Device, "CountryCodeConfig", this.country)
      .subscribe((data) => {
        if (data.length >= 0) {
          this.dataLoader = true;
          this.successfulData = {
            countryCodeConfigurations: data,
            selected: {},
          };
          this.allItems = data;
          // initialize to page 1
          this.setPage(1);
          this.dataLoader = false;
        }
      });
  }
  GetDropDownValues() {
    this.capservice.DropdownValues("AGList", "All").subscribe((data) => {
      this.AGList = data;
    });
    this.capservice.DropdownValues("UseCaseList", "All").subscribe((data) => {
      this.UseCaseList = data;
      this.dataLoader = false;
    });
  }

  DeviceTypeEvent(event: any) {
    //Paginator.page = 0;
    this.ClearDevice();
    this.Device = event.target.value;
    if (
      this.Device == "Skype" ||
      this.Device == "Cisco" ||
      this.Device == "Teams"
    ) {
      $("#AlertForAccess").css("display", "none");
      $("#divCountryCodeCommon").css("display", "block");
      $("#divCountryCodeSubmit").css("display", "block");
      $("#divCountryCodeDetails").css("display", "block");

      //Load Grid Data
      this.InitLoad();
    } else {
      $("#AlertForAccess").css("display", "block");
      $("#divCountryCodeCommon").css("display", "none");
      $("#divCountryCodeSubmit").css("display", "none");
      $("#divCountryCodeDetails").css("display", "none");
    }
  }

  ShowData() {
    //Paginator.page = 0;

    if ($("#dlstUseCase").val() == "" && $("#dlstCountry").val() == "") {
      $("#divCountryCodeDetails").css("display", "none");
      alert("Please select value to search");
      }
    else {
      var UseCase = $('#dlstUseCase').val() == '' ? 'N' : $('#dlstUseCase').val()
      if (this.Role != 'Global Admin') {
        var Country = $('#dlstCountry').val() == '' ? this.Country : $('#dlstCountry').val();
      }
      else {
        Country = $('#dlstCountry').val() == '' ? 'N' : $('#dlstCountry').val();

      }
      if (this.Device == 'Teams') {
        this.capservice.SearchDetailsConfig(UseCase, Country,
          'N', this.Device, "CountryCodeConfig").subscribe(data => {
            if (data.length > 0) {
              this.successfulData = {
                countryCodeConfigurations: data,
                selected: {},
              };
              this.allItems = data;
              // initialize to page 1
              this.setPage(1);
              $("#divCountryCodeDetails").css("display", "block");
            } else {
              $("#divCountryCodeDetails").css("display", "none");
              alert("No Records Found");
            }
          });
      } else {
        this.capservice
          .SearchDetails(
            UseCase,
            Country,
            "N",
            this.Device,
            "CountryCodeConfig"
          )
          .subscribe((data) => {
            if (data.length > 0) {
              this.successfulData = {
                countryCodeConfigurations: data,
                selected: {},
              };
              this.allItems = data;
              // initialize to page 1
              this.setPage(1);
              $("#divCountryCodeDetails").css("display", "block");
            } else {
              $("#divCountryCodeDetails").css("display", "none");
              alert("No Records Found");
            }
          });
      }
    }
  }
  ExportToBulkExcel() {
    debugger;
    var ReportName = 'Country_Code_Configuration.xlsx';

      var UseCase = $('#dlstUseCase').val() == '' ? 'N' : $('#dlstUseCase').val()
      if (this.Role != 'Global Admin') {
        var Country = $('#dlstCountry').val() == '' ? this.Country : $('#dlstCountry').val();
      }
      else {
        Country = $('#dlstCountry').val() == '' ? 'N' : $('#dlstCountry').val();
    }

    this.capservice
      .SearchDetailsBulkDownload(
        UseCase,
        Country,
        "N",
        this.Device,
        "CountryCodeConfig"
      )
      .subscribe(
        (data: Blob) => {
          this.dataLoader = true;
          if (data.size > 0) {
            if (
              window.navigator &&
              (window.navigator as any).msSaveOrOpenBlob
            ) {
              // for IE
              (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
              this.dataLoader = false;
          }
            else{
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(data);
              link.download = ReportName;
              link.click();
              this.dataLoader = false;
            }
          } else {
            alert("No Records Found");
            this.dataLoader = false;
          }
        },
        function (x) {
          console.log(x);
          this.dataLoader = false;
          alert("Acknowledgement failed");
        }
      );
  }

  CountryCodeAdd() {
    var message = ''
    if ($('#grdfCountry').val() == '') {
      message = "Please Select Country";
    }
    if ($("#grdfCountryCode").val() == "") {
      message = message + "\n" + "Please Enter Country Code";
    }
    if ($("#grdfAG").val() == "") {
      message = message + "\n" + "Please Select Facility Type";
    }
    if ($("#grdfUseCase").val() == "") {
      message = message + "\n" + "Please Select Use Case";
    }

    if (message != "") {
      alert(message);
    } else {
      //this.CountryCodeDetails.Name = (MYCASService.encryptedlogin(this.CountryCodeDetails.Name)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.CountryCodeDetails.Code = (MYCASService.encryptedlogin(this.CountryCodeDetails.Code)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.CountryCodeDetails.AG = (MYCASService.encryptedlogin(this.CountryCodeDetails.AG)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.CountryCodeDetails.UseCase = (MYCASService.encryptedlogin(this.CountryCodeDetails.UseCase)).ciphertext.toString(CryptoJS.enc.Base64);
      this.CountryCodeDetails.DeviceType = this.Device;
      this.CountryCodeDetails.EnterpriseID = this.LoginEnterpriseID;
      this.CountryCodeDetails.strType = "CountryCodeConfig";
      //this.CountryCodeDetails.token = MYCASService.tokenManager();

      this.capservice
        .InsertVoiceAdminDetails(this.CountryCodeDetails)
        .subscribe((data) => {
          if (data.toString() == "Failed") {
            alert("Inserted Successfully");
            this.clear();
          } else {
            alert(data);
            this.clear();
          }
        });
    }
  }
  EditCountryCode(countryCodeConfiguration) {
    this.successfulData.selected = Object.assign({}, countryCodeConfiguration); //angular.copy(countryCodeConfiguration);
  }
  DeleteCountryCode(countryCodeConfiguration) {
    this.capservice
      .DeleteVoiceAdminDetails(
        countryCodeConfiguration.Id,
        "CountryCodeConfig",
        this.LoginEnterpriseID,
        null
      )
      .subscribe((data) => {
        if (data.length > 0) {
          alert("Deleted Successfully");
          this.clear();
        } else {
          alert(data);
          this.clear();
        }
      });
  }
  CountryCodeUpdate(countryCodeConfiguration) {
    var message = ''
    if ($('#grdCountry').val() == '') {
      message = "Please Select Country";
    }
    if ($("#grdCountryCode").val() == "") {
      message = message + "\n" + "Please Enter Country Code";
    }
    if ($("#grdAG").val() == "") {
      message = message + "\n" + "Please Select Facility Type";
    }
    if ($("#grdUseCase").val() == "") {
      message = message + "\n" + "Please Select Use Case";
    }

    if (message != "") {
      alert(message);
    } else {
      //this.successfulData.countryCodeConfigurations[idx] = angular.copy(this.successfulData.selected);
      //this.successfulData.selected.Name = (MYCASService.encryptedlogin(this.successfulData.selected.Name)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.successfulData.selected.Code = (MYCASService.encryptedlogin(this.successfulData.selected.Code)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.successfulData.selected.AG = (MYCASService.encryptedlogin(this.successfulData.selected.AG)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.successfulData.selected.UseCase = (MYCASService.encryptedlogin(this.successfulData.selected.UseCase)).ciphertext.toString(CryptoJS.enc.Base64);
      this.successfulData.selected.ID1 =
        this.successfulData.selected.Id.toString();
      this.successfulData.selected.Id = this.successfulData.selected.Id;
      this.successfulData.selected.DeviceType = this.Device;
      this.successfulData.selected.strType = "CountryCodeConfig";
      this.successfulData.selected.EnterpriseID = this.LoginEnterpriseID;
      //this.successfulData.selected.token = MYCASService.tokenManager();

      this.capservice
        .UpdateVoiceAdminDetails(this.successfulData.selected)
        .subscribe((data) => {
          if (data.toString() == "Failed") {
            alert("Updated Successfully");
            this.clear();
          } else {
            alert(data);
            this.clear();
          }
        });
    }
  }
  reset() {
    this.successfulData.selected = {};
  }
  clear() {
    $("#grdfCountry").val("");
    $("#grdfCountryCode").val("");
    $("#grdfUseCase").val("");
    $("#grdfAG").val("");
    $("#grdCountry").val("");
    $("#grdCountryCode").val("");
    $("#grdUseCase").val("");
    $("#grdAG").val("");
    $("#dlstCountry").val("");
    $("#dlstUseCase").val("");
    //this.DeviceTypeEvent();
    this.InitLoad();
    $("#divCountryCodeDetails").css("display", "block");
  }
  ClearDevice() {
    $("#grdfCountry").val("");
    $("#grdfCountryCode").val("");
    $("#grdfUseCase").val("");
    $("#grdfAG").val("");
    $("#grdCountry").val("");
    $("#grdCountryCode").val("");
    $("#grdUseCase").val("");
    $("#grdAG").val("");
    $("#dlstCountry").val("");
    $("#dlstUseCase").val("");
  }
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.countryCodeConfigurations = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
}
